import { toDate as o } from "./toDate.js";
function r(t) {
  return o(t).getMonth();
}
export {
  r as default,
  r as getMonth
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getMonth.js
// module id = 446
// module chunks = 67